<template>
  <div>
    <v-container class="grey lighten-5" fluid>
      <v-row>
        <v-col cols="12">
          <h1>Dodaj stronę dla modelu samochodu</h1>
          <v-tabs v-model="tab">
            <v-tab>
              Paragrafy
            </v-tab>
            <v-tab>
              Dane
            </v-tab>
            <v-tab>
              Meta Dane
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-card>
                <v-card-text>
                  <p>Chcesz zmienić kolejność paragrafów? Złap i przeciągnij w górę/dół paragraf (złap za toolbar edytora lub z lewej strony edytora).</p>
                  <v-form>
                      <v-btn
                          @click="addParagraph"
                      >
                          Dodaj nowy paragraf
                      </v-btn>
                    <v-row>
                      <draggable v-model="draggableParagraphs">
                      <template v-for="(paragraph, index) in pageDetails.text.p">
                        <v-col cols="12" v-bind:key="index">
                          <ckeditor
                              :editor="editor"
                              v-model="pageDetails.text.p[index]"
                              :config="editorConfig"
                          ></ckeditor>
                        <span class="v-btn" @click="deleteParagraph(index)">Usuń paragraf</span>
                        </v-col>
                      </template>
                      </draggable>
                    </v-row>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
                  <v-card>
                      <v-card-text>
                          <v-form>
                            <v-row>
                              <v-col cols="6" class="ml-2 mr-2">
                                <v-autocomplete
                                    v-model="pageDetails.service"
                                    :items="services"
                                    :menu-props="{ maxHeight: '400' }"
                                    item-text="name"
                                    item-value="id"
                                    label="Samochód"
                                ></v-autocomplete>
                              </v-col>
                            </v-row>
                              <v-row>
                                  <v-col cols="12">
                                      <v-text-field v-model="pageDetails.pageTitle" class="col-6" label="Tytuł na stronie" hint="Tytuł na stronie"></v-text-field>
                                  </v-col>
                              </v-row>
                          </v-form>
                      </v-card-text>
                  </v-card>
          </v-tab-item>
            <v-tab-item>
              <v-card>
                <v-card-text>
                  <v-form>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field v-model="pageDetails.title" class="col-6" label="Tytuł" hint="Tytuł"></v-text-field>
                        <v-text-field v-model="pageDetails.description" class="col-12" label="Opis" hint="Opis"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
          <v-spacer/>
          <v-btn
              @click="savePageDetails"
          >
            Zapisz
            <v-icon size="24" right>
              mdi-content-save-outline
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <modal-loader :show="loading" />
  </div>
</template>

<script>
import api from '../services/api';
import permissions from "@/mixins/permissions";
import ModalLoader from "../components/ModalLoader";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import ClassicEditor from '../utils/ckeditor5/build/ckeditor';
import draggable from "vuedraggable";

export default {
  components: {
    ModalLoader,
    ckeditor: CKEditor.component,
    draggable,
  },
  mixins: [
    permissions,
  ],
  props: ['id'],
  data() {
    return {
      services: [],
      editor: ClassicEditor,
      editorConfig: {
        id: this.id,
        htmlSupport: {
          allow: [
            {
              name: /.*/,
              attributes: true,
              classes: true,
              styles: true
            }
          ],
        },
        heading: {
          options: [
            {
              model: 'paragraph',
              title: 'Paragraph',
              class: 'ck-heading_paragraph',
            },
            {
              model: 'heading1',
              view: 'h1',
              title: 'Heading 1',
              class: 'ck-heading_heading1',
            },
            {
              model: 'heading2',
              view: 'h2',
              title: 'Heading 2',
              class: 'ck-heading_heading2',
            },
            {
              model: 'heading3',
              view: 'h3',
              title: 'Heading 3',
              class: 'ck-heading_heading3',
            },
            {
              model: 'heading4',
              view: 'h4',
              title: 'Heading 4',
              class: 'ck-heading_heading4',
            },
            {
              model: 'heading5',
              view: 'h5',
              title: 'Heading 5',
              class: 'ck-heading_heading5',
            },
            {
              model: 'heading6',
              view: 'h6',
              title: 'Heading 6',
              class: 'ck-heading_heading6',
            },
          ],
        },
      },
      loading: false,
      loadingDetails: false,
      pageDetails: {
        text: {
          p: [],
          m: []
        },
        opinions: {
          o: []
        },
        recentSales: {
          o: []
        },
        service: null
      },
      tab: null,
    }
  },
  methods: {
    async savePageDetails() {
      if (!this.pageDetails.pageTitle) {
        this.$root.$emit('notifyError', {
          html: 'Dane: Tytuł na stronie jest wymagany.'
        });
        return;
      }

      if (!this.pageDetails.title) {
        this.$root.$emit('notifyError', {
          html: 'Meta dane: Tytuł jest wymagany.'
        });
        return;
      }

      this.loading = true;

      try {
        if (typeof this.pageDetails.service === 'object') {
          this.pageDetails.service = this.pageDetails.service.id;
        }
        const data = await api.post(`/api/car-page-content`, this.pageDetails);
        this.$router.push({name: 'car-page-content-details', params: {id: data.data.id}});
      } catch (error) {
        /** @see https://github.com/axios/axios#handling-errors */
        this.loading = false;
        this.$root.$emit('notifyError', {
          html: 'Nie udało się zapisać danych strony.',
          error
        });

        return;
      }

      this.loading = false;
      this.$root.$emit('notifySuccess', {
        html: 'Dane strony zostały zapisane.'
      });
    },
    deleteParagraph(index) {
        this.pageDetails.text.p.splice(index, 1);
    },
    addParagraph() {
        this.pageDetails.text.p.push('');
    },
    async getServices() {
      const response = await api.get('/api/service/autocomplete?limit=5000');
      this.services = response.data.items;
    }
  },
  computed: {
    draggableParagraphs: {
      get() {
        return this.pageDetails.text.p
      },
      set(val) {
        this.pageDetails.text.p = val
      }
    }
  },
  created() {
    this.getServices();
  }
}
</script>

<style scoped>
</style>
